import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonUtils } from '../../../../common/common-utils';
import { NgClass } from '@angular/common';
import { ImportLogItem } from '../../../../../shared/models/report/import-log-item';

@Component({
  selector: 'app-translation-import-reporter',
  imports: [NgClass],
  templateUrl: './translation-import-reporter.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './translation-import-reporter.component.scss',
})
export class TranslationImportReporterComponent {
  @Input() public reports: ImportLogItem[] = [];
  @Input() public title = 'Translation Import Report';

  public commonUtils = CommonUtils;

  public getSortedReports(): ImportLogItem[] {
    if (!this.reports) return [];

    return [...this.reports].sort((a, b) => {
      return (a.languageCode || '').localeCompare(b.languageCode || '');
    });
  }
}
